module.exports = __webpack_public_path__ + "img/yes.8239082d.png";